import Card from 'app/shared-components/Card'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import useTableStyles from 'app/tss/table.styles'
import useCardForTableStyles from 'app/tss/cardForTable'

import requestConfig from 'app/requests/ServiceCenter/ServiceCenter.requests'
import tableConfig from './inboundOrders.config'

const InboundOrders = ({
    serviceCenterId,
}: { serviceCenterId: number }) => {
    const {
        classes: cardClasses,
    } = useCardForTableStyles()
    const {
        classes: tableClasses,
    } = useTableStyles()

    return (
        <Card
            title="Inbound Orders"
            className={cardClasses.root}
        >
            <SkyNetTable
                name="InboundOrders"
                tableConfig={tableConfig}
                customUrl={requestConfig.inboundOrders({
                    serviceCenterId,
                }).url}
                simple
                className={tableClasses.table}
            />
        </Card>
    )
}

export default InboundOrders
